// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_routes_reports_reports_module_ts":"a857ca9b17aaf398","src_app_bulk-user-update_bulk-user-update_module_ts":"f93bbff5581c1cdb"}[chunkId] + ".js";
};